import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';

import * as AuthActions from '../../auth/store/actions/auth.actions';
import * as UserPortfolioActions from './user-portfolio.actions';
import { UserPortfolioService } from '../../services/user-portfolio.service';

@Injectable()
export class UserPortfolioEffects {

  public getUsersInvites$ = createEffect(() => {
    return this._actions.pipe(
      ofType(UserPortfolioActions.getUserInvations),
      switchMap(() => {
        return this._userPortfolioService.getUserInvitations()
          .pipe(
            switchMap(({ data }) => of(
              UserPortfolioActions.getUserInvationsSuccess({ data }),
            ),
          ),
        )
      }),
    )
  });

  public acceptInvite$ = createEffect(() => {
    return this._actions.pipe(
      ofType(UserPortfolioActions.acceptInvite),
      switchMap(({ inviteId }) => {
        return this._userPortfolioService.processInvite(inviteId, '', '', true)
          .pipe(
            switchMap(() => of(
              UserPortfolioActions.getUserInvations(),
              AuthActions.updatePermissions(),
            ),
          ),
        )
      }),
    )
  });

  public rejectInvite$ = createEffect(() => {
    return this._actions.pipe(
      ofType(UserPortfolioActions.rejectInvite),
      switchMap(({ inviteId }) => {
        return this._userPortfolioService.processInvite(inviteId, '', '', false)
          .pipe(
            switchMap(() => of(
                UserPortfolioActions.getUserInvations(),
              ),
            ),
          )
      }),
    )
  });

  public clearStore$ = createEffect(() => {
    return this._actions.pipe(
      ofType(AuthActions.logout),
      switchMap(() => of(UserPortfolioActions.clearStore())),
    )
  });

  constructor(
    private _actions: Actions,
    private _userPortfolioService: UserPortfolioService,
  ) {}
}
